<h1>{{ title || ( getLabel(path) | translate) }}</h1>